var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStethoscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3.5C8.33579 3.5 7.77241 3.93171 7.57516 4.52985C6.1195 4.7362 5 5.98736 5 7.5V12C5 14.8771 7.20912 17.2382 10.0237 17.4797C10.28 20.0311 12.5746 21.3737 14.7353 21.4373C15.8942 21.4714 17.0807 21.1491 17.9875 20.4113C18.9072 19.6628 19.5 18.5172 19.5 17V13H18.5V17C18.5 18.2328 18.0303 19.0872 17.3563 19.6356C16.6693 20.1946 15.7308 20.4661 14.7647 20.4377C12.9568 20.3845 11.2774 19.3204 11.031 17.4747C13.8194 17.2076 16 14.8584 16 12V7.5C16 6.17911 15.1463 5.05761 13.9606 4.6571C13.8055 3.99391 13.2105 3.5 12.5 3.5C11.6716 3.5 11 4.17157 11 5C11 5.82843 11.6716 6.5 12.5 6.5C13.0826 6.5 13.5876 6.16785 13.836 5.68259C14.5231 5.99918 15 6.6939 15 7.5V12C15 14.4853 12.9853 16.5 10.5 16.5C8.01472 16.5 6 14.4853 6 12V7.5C6 6.53237 6.68717 5.72524 7.60013 5.53998C7.81691 6.1016 8.36193 6.5 9 6.5C9.82843 6.5 10.5 5.82843 10.5 5C10.5 4.17157 9.82843 3.5 9 3.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 11.5C17 10.3954 17.8954 9.5 19 9.5C20.1046 9.5 21 10.3954 21 11.5C21 12.6046 20.1046 13.5 19 13.5C17.8954 13.5 17 12.6046 17 11.5ZM19 12C19.2761 12 19.5 11.7761 19.5 11.5C19.5 11.2239 19.2761 11 19 11C18.7239 11 18.5 11.2239 18.5 11.5C18.5 11.7761 18.7239 12 19 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStethoscope);
export default __webpack_public_path__ + "static/media/Stethoscope.c2412d07.svg";
export { ForwardRef as ReactComponent };